import gql from 'graphql-tag';
import {useMutation} from '@apollo/client';

const MUTATION = gql`
  mutation submitTrainingMaterialsRequest($request: TrainingMaterialsRequest!) {
    submitTrainingMaterialsRequest(request: $request) {
      statusCode
      message
    }
  }
`;

export interface TrainingMaterialsRequest {
  email: string;
  message: string;
}

export interface TrainingMaterialsRequestResponse {
  statusCode: number;
  message: string;
}

const useSubmitTrainingMaterialsRequest = (onCompleted = (_response: any) => {
}) => {
  const [action] = useMutation(MUTATION, { onCompleted });

  return (request: TrainingMaterialsRequest) => {
    return action({ variables: { request } });
  };
};

export default useSubmitTrainingMaterialsRequest;
